// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"873c4199","667":"ae5eacbc"}[chunkId] + ".chunk.js";
};